module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-27.e30f1cc4.png";